import { useEffect } from 'react';
import { useLocation } from 'wouter';

// Use any-typed reference to avoid conflicts with existing Window type declarations
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const w = window as any;

export default function Analytics() {
  const [location] = useLocation();

  useEffect(() => {
    // Defer all analytics until after the page is interactive to avoid
    // competing with critical resources during initial load
    const timer = setTimeout(() => {
      // Google Analytics 4 Initialization
      const gaId = import.meta.env.VITE_GA_ID || 'G-XXXXXXXXXX';

      if (!w.gtag) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);

        w.dataLayer = w.dataLayer || [];
        w.gtag = function() {
          w.dataLayer.push(arguments);
        };
        w.gtag('js', new Date());
        w.gtag('config', gaId);
      }

      // LinkedIn Insight Tag Initialization
      const linkedinId = import.meta.env.VITE_LINKEDIN_ID || 'XXXXXXX';
      if (!document.getElementById('linkedin-insight')) {
        const script = document.createElement('script');
        script.id = 'linkedin-insight';
        script.innerHTML = `
          _linkedin_partner_id = "${linkedinId}";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);})(window.lintrk);
        `;
        document.head.appendChild(script);
      }

      // Meta Pixel Initialization
      const metaPixelId = import.meta.env.VITE_META_PIXEL_ID || 'XXXXXXXXXXXXXXX';
      if (!document.getElementById('meta-pixel')) {
        const script = document.createElement('script');
        script.id = 'meta-pixel';
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${metaPixelId}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // Track Page Views on Route Change
  useEffect(() => {
    if (w.gtag) {
      w.gtag('event', 'page_view', { page_path: location });
    }
    if (w.fbq) {
      w.fbq('track', 'PageView');
    }
  }, [location]);

  return null;
}
